import { FC, useState } from "react";
import { ColorPickerPopup } from "shared/ui";
import type { FractalChaosBandsSettings, FractalColorStyle } from "../../model";
import styles from "./ADXStylesTab.module.css";

type ColorKey = "up" | "down" | "background";

const COLORS: { key: ColorKey; label: string }[] = [
  { key: "up", label: "up" },
  { key: "down", label: "down" },
  { key: "background", label: "background" },
];

interface Props {
  settings: FractalChaosBandsSettings;
  onChange: (s: FractalChaosBandsSettings) => void;
}

export const FractalChaosBandsStylesTab: FC<Props> = ({ settings, onChange }) => {
  const [openPopup, setOpenPopup] = useState<ColorKey | null>(null);

  const toggle = (key: ColorKey) =>
    setOpenPopup((prev) => (prev === key ? null : key));

  const updateColor = (key: ColorKey, patch: Partial<FractalColorStyle>) =>
    onChange({ ...settings, [key]: { ...settings[key], ...patch } });

  return (
    <div className={styles.tab}>
      {COLORS.map(({ key, label }) => (
        <div key={key} className={styles.row}>
          <div className={styles.left}>
            <label className={styles.checkboxWrap}>
              <input
                type="checkbox"
                className={styles.checkboxInput}
                checked={settings[key].visible}
                onChange={(e) => updateColor(key, { visible: e.target.checked })}
              />
              <span className={styles.checkmark} />
            </label>
            <span className={styles.label}>{label}</span>
          </div>
          <div className={styles.btnWrap}>
            <button
              className={styles.colorBtn}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={() => toggle(key)}
            >
              <span className={styles.colorBtnSwatch} style={{ background: settings[key].color }} />
            </button>
            {openPopup === key && (
              <ColorPickerPopup
                color={settings[key].color}
                onChange={(c) => updateColor(key, { color: c })}
                onClose={() => setOpenPopup(null)}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
